<template>
  <div class="badge-container">
    <p>NEW!</p>
  </div>
</template>
<style scoped>
.badge-container {
  width: auto;
  height: auto;
  background-color: #5ba4a4;
  border-radius: 20px;
  margin-left: 0.9rem;
}
p {
  color: #fff;
  font-weight: 700;
  font-size: 0.6rem;
  margin: 0.5rem 0.6rem;
}
</style>
